<script>
  import Modal from '@components/general/modal.svelte'
  import Text from '@components/general/text.svelte'
  import Message from '@components/general/message.svelte'
  import Button from '@components/buttons/button.svelte'
  import LoadingArea from '@components/general/loading-area.svelte'
  import { RefreshCw } from 'lucide-svelte'
  import { get, post } from '@rails/request.js'
  import { router } from '@inertiajs/svelte'
  import { formatObject, formatDetails } from '@lib/utils'

  let { sync, lastSyncText, reset } = $props()

  let formDisabled = $derived(sync.loading || !!sync.results)

  async function performSync() {

    sync.processing = true
    sync.results = null
    sync.error = null
    try {
      const response = await post('/api/v1/live_sessions/perform_sync')
      const json = await response.json
      if (!response.ok) {
        sync.error = {
          message: 'Error syncing live sessions',
          details: json?.errors ?? json,
        }
        return
      }

      sync.results = json
      router.reload()
    } catch (e) {
      sync.error = { message: e?.message || 'Error syncing live sessions', details: e }
    } finally {
      sync.processing = false
    }
  }

</script>

<Modal bind:open={sync.open} title="Fetch live sessions from Arlo" onClose={reset}>

  {#if sync.processing}
    <LoadingArea message="Fetching live sessions from Arlo collection..." />
  {:else if sync.error}
    <Message type="error" title={sync.error.message || "Error syncing live sessions"}>
      {#if sync.error.details}
        <pre class="text-xs text-gray-700 whitespace-pre-wrap wrap-break-word">{formatDetails(sync.error.details)}</pre>
      {/if}
      <Button variant="link" onclick={reset} text="Clear results" />
    </Message>
  {:else if sync.results}
    <Message type="success" title="Live sessions fetched successfully">
      <p>{formatObject(sync.results)}</p>
      <Button variant="link" onclick={reset} text="Clear results" />
    </Message>
  {:else}
    <Text text="Fetch live sessions from Arlo collection" />
    <Text variant="prose" text={lastSyncText} class="text-smaller text-gray-500 italic mt-4" />
  {/if}

  {#snippet footer()}
    <Button variant="primary" onclick={performSync} loading={sync.processing} disabled={formDisabled} Icon={RefreshCw} text="Perform sync" />
  {/snippet}
</Modal>